import Vue from 'vue';
import axios from 'axios';
import VModal from 'vue-js-modal';
import { Datetime } from 'vue-datetime';
import VueCal from 'vue-cal';
import supportedLocales from '@/config/supported-locales';
import Echo from 'laravel-echo';
import ToastrMixin from '@/mixins/ToastrMixin';
import dayjs from 'dayjs';
import VueMaterial from 'vue-material';
import { Swatches } from 'vue-color';
import VueAutosuggest from 'vue-autosuggest';
import InstantSearch from 'vue-instantsearch';
import VueToastr from 'vue-toastr';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/tailwind.css';
import i18n from './i18n';

const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');
const localizedFormat = require('dayjs/plugin/localizedFormat');
const isBetween = require('dayjs/plugin/isBetween');
require('dayjs/locale/de');
require('dayjs/locale/it');

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(isBetween);

Vue.use(Datetime, dayjs);

Vue.config.productionTip = false;
axios.defaults.withCredentials = true;
Vue.use(VModal, {
  dynamic: true,
  resizable: true,
  dialog: true,
  adaptive: true,
});

Vue.use(VueToastr);

Vue.component('datetime', Datetime);

Vue.component('vue-cal', VueCal);

Vue.component('swatches-picker', Swatches);

Vue.mixin(ToastrMixin);

Object.keys(supportedLocales).forEach(async (locale) => {
  if (locale !== 'en') { await import(`vue-cal/dist/i18n/${locale}`); }
});

Vue.prototype.formatter = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: process.env.VUE_APP_CURRENCY,
  minimumFractionDigits: 2,
});

Vue.use(VueMaterial);

Vue.use(InstantSearch);
Vue.use(VueAutosuggest);

store.dispatch('auth/me').then(() => {
  new Vue({
    router,
    store,
    i18n,
    VModal,
    VueCal,
    Datetime,
    dayjs,
    render: (h) => h(App),
  }).$mount('#app');
});

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  forceTLS: true,
});
